import React, {Component} from "react";
import { Link } from "react-router-dom";
import './Sidebare.css'
import logo from '../images/logo_transparent.png'
import '../font_awesome/css/font-awesome.min.css'

class Sidebare extends Component {
    logout = () => {
        try {
            this.props.history.push("/")
        } catch (e) {

        }

    }

    render() {
        return(
            <div className="sidebarre-sidebare">
                <div className='img-sidebare'>
                    <img alt='' src={logo}/>
                </div>
                
                <div className="menu-list">
                    <Link to="/" className="bar-item"><i className="fa fa-users fa-2x"></i> قائمة الطلبة</Link>
                    <Link to="/recherche" className="bar-item"><i className="fa fa-search fa-2x"></i> بحث عن طالب</Link>
                    <Link to="/inscription" className="bar-item"><i className="fa fa-user-plus fa-2x"></i> تسجيل طالب جديد</Link>
                    <Link to="/reinscription" className="bar-item"><i className="fa fa-retweet fa-2x"></i> إعادة التسجيل</Link>
                    <Link to="/transfert" className="bar-item"><i className="fa fa-exchange fa-2x"></i> تحويل طالب</Link>
                    <Link to="/absence" className="bar-item"><i className="fa fa-edit fa-2x"></i> تبرير الغيابات</Link>
                    <Link to="/certificat" className="bar-item"><i className="fa fa-file fa-2x"></i> شهادة مدرسية</Link>
                    <Link to="/gerer_utilisateurs" className="bar-item"><i className="fa fa-cubes fa-2x"></i> إدارة الحسابات</Link>
                </div>
                <div className="logout">
                    <Link to='/' className="bar-item" onClick={this.logout}><i className="fa fa-sign-out fa-2x"></i> تسجيل الخروج</Link>
                </div>
            </div>

        )
    }
}

export default Sidebare